// @flow
import type { Dispatch, GetState } from 'state/types';
import { actions } from 'portfolio-shared/state/reducers/persistReducer';
import { actions as reachoutActions } from 'portfolio-shared/state/reducers/reachoutReducer';
import { persistNewDismissedReachoutMessageId } from 'portfolio-shared/util/reachoutUtils';
import { getDismissedMessageIds, getReachoutMessages } from 'state/selectors';
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from 'portfolio-shared/util/persistenceUtils';
import { actions as intlActions } from 'portfolio-shared/state/reducers/intlReducer';
import { STORAGE_KEY, USER_DATA } from 'util/constants';

const { LOCALE } = USER_DATA;

const { setLocale } = intlActions;
const { persist: persistAction } = actions;

function persist(persistData: Object) {
  return persistAction((dispatch, getState) => {
    saveToLocalStorage(STORAGE_KEY, persistData);
  });
}

function loadPersistedData() {
  return async function loadPersistData(dispatch: Dispatch) {
    const userData = getFromLocalStorage(STORAGE_KEY);
    if (userData[LOCALE]) {
      await dispatch(setLocale(userData[LOCALE]));
    }

    if (userData.dismissedMessageIds) {
      dispatch(
        reachoutActions.setDismissedMessageIds(userData.dismissedMessageIds)
      );
    }
  };
}

function addDismissedReachoutMessageId(id: string) {
  return function addDismissedReachoutMessageId(
    dispatch: Dispatch,
    getState: GetState
  ) {
    persistNewDismissedReachoutMessageId(
      id,
      getDismissedMessageIds(getState()),
      getReachoutMessages(getState()),
      newIdArray => {
        dispatch(reachoutActions.setDismissedMessageIds(newIdArray));
        dispatch(persist({ dismissedMessageIds: newIdArray }));
      }
    );
  };
}

export { addDismissedReachoutMessageId, loadPersistedData, persist };



// WEBPACK FOOTER //
// ./src/state/commands/persistCommands.js